import { render, staticRenderFns } from "./yesScoreDetails.vue?vue&type=template&id=0ab96b9f&scoped=true&"
import script from "./yesScoreDetails.vue?vue&type=script&lang=js&"
export * from "./yesScoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./yesScoreDetails.vue?vue&type=style&index=0&id=0ab96b9f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab96b9f",
  null
  
)

export default component.exports